export default __webpack_public_path__ + "static/media/logo_nl.e5ccba81.png";